document.addEventListener("DOMContentLoaded", () => {
   ///IOS remove automatic <a tag
    let fr = $('.counter').html();
    let fg = fr.replace(/\<(?!img|br).*?\>/g, "");

    $('.counter').html(fg);
   //IOS remove automatic <a tag



    function diff_hours(dt2, dt1) 
    {
   
     let diff =(dt2.getTime() - dt1.getTime()) / 1000;
     diff /= (60 * 60);
     return Math.abs(Math.round(diff));
     
    }

    let getStartDate = $('.counter').attr('data-start');
    let getNappiesSavedPerHour = parseInt($('.counter').attr('data-nappies'));
   
    let dt11 = new Date(getStartDate.replace(/-/g, "/"));
    dt2 = new Date();


    // safari date format converter
    let formatStart = String(dt2).split(' '); 
    let getmm = formatStart[1];
    console.log(getmm);
    let convertMM;
    if(getmm == 'Jan'){
        convertMM = '01';
    }if(getmm == 'Feb'){
        convertMM = '02';
    }if(getmm == 'Mar'){
        convertMM = '03';
    }if(getmm == 'Apr'){
        convertMM= '04';
    }if(getmm == 'May'){
        convertMM = '05';
    }if(getmm == 'Jun'){
        convertMM = '06';
    }if(getmm == 'Jul'){
        convertMM = '07';
    }if(getmm == 'Aug'){
        convertMM = '08';
    }if(getmm == 'Sep'){
        convertMM = '09';
    }if(getmm == 'Oct'){
        convertMM = '10';
    }if(getmm == 'Nov'){
        convertMM = '11';
    }if(getmm == 'Dec'){
        convertMM = '12';
    }

    let fotmatedText = convertMM+"/"+formatStart[2]+"/"+formatStart[3];
    let dt3 = new Date(fotmatedText.replace(/-/g, "/"));
    let counterAmount = parseInt($(".counter").html());
    let currentAmount = counterAmount + (getNappiesSavedPerHour * parseInt(diff_hours(dt11, dt3)));
    let couterNumber = parseInt(currentAmount);

    $(".counter").html(couterNumber);
    $(".counter").lettering();


    let getHeight = $(".counter").find('span').height();
    let getspan = $(".counter").find('span').length;
    for(let i = 0; i < getspan; i++){
      let getnumber = $(".counter").find('span').eq(i).html();
      $(".counter").find('span').eq(i).append('<ul></ul>')
             for(let j = 0; j< 9; j++ ){
              let randomNumber = Math.floor(Math.random() * 9); 
                if(j == 0){
                    $(".counter").find('span').eq(i).find('ul').append('<li>'+getnumber+'</li>');
                }else{
                    $(".counter").find('span').eq(i).find('ul').append('<li>'+randomNumber+'</li>');
                }
              $(".counter").find('span').eq(i).find('ul').css('top',((getHeight*randomNumber)*-1)+'px');
             } 
       $(".counter").find('span').eq(i).find('ul').append('<li>'+getnumber+'</li>');
       } 
      
       var animation = anime({
        targets: '.counter span ul',
        duration: 1500,
        autoplay: false,
        top: ['0px'],
        delay: function(el, i) { return i * 100; },
        easing: 'easeOutQuart'
   });
   var controlView = 0;  
   $(window).scroll(function(){
    // This is then function used to detect if counter is scrolled into view
    function elementScrolled(elem)
    {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $(elem).offset().top;
        return ((elemTop <= docViewBottom) && (elemTop >= docViewTop));
    }
     
    // This is where we use the function to detect if ".counter" is scrolled into view, and when it is start animation
  
    if(elementScrolled('.counter')) {
        if(controlView == 0){
            animation.restart();
            controlView = 1;
        }
      
    }
  });

       
  });